import { ActionTypes }        from 'actions/types';
import { contentReducerType } from 'reducer/types';
import homeapp                from './homePageApp';


export const initialContentState: contentReducerType = {
  hash:              {},
  bigContentArr:     [],
  homePageApp:       homeapp,
  apps:              [],
  interaction:       [],
  lessons:           [],
  puzzles:           [],
  bigTeacherArr:     [],
  teacherLessons:    [],
  mivdakim:          [],
  groupUrlContent:   [],
  allContent:        [],
  tutorials:         [],
  userVideos:        [],
  selectedApp:       {},
  userLessonsState:  { userLessons: [],  userLessonsFound: false,  showUserLessonsLoader: false },
  groupLessonsState: { groupName: '', groupLessons: [], groupLessonsFound: false, showGroupLessonsLoader: false },
  getContentOnce:    false,
};

const contentReducer = (state = initialContentState, action: ActionTypes) => {

  switch (action.type) {


//SET_CONTENT   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_CONTENT':

  {

    const { bigContentArr, apps, interaction, puzzles, lessons, bigTeacherArr, teacherLessons, mivdakim, hash } = action.payload;

    
    return {
      ...state,
      bigContentArr:  !!bigContentArr  ? bigContentArr  : state.bigContentArr,
      allContent:     !!bigContentArr  ? bigContentArr  : state.bigContentArr,
      apps:           !!apps           ? apps           : state.apps,
      interaction:    !!interaction    ? interaction    : state.interaction,
      puzzles:        !!puzzles        ? puzzles        : state.puzzles,
      lessons:        !!lessons        ? lessons        : state.lessons,
      bigTeacherArr:  !!bigTeacherArr  ? bigTeacherArr  : state.bigTeacherArr,
      teacherLessons: !!teacherLessons ? teacherLessons : state.teacherLessons,
      mivdakim:       !!mivdakim       ? mivdakim       : state.mivdakim,
      hash:           !!hash           ? hash           : state.hash
    }


  }


  case 'SET_ALL_CONTENT':
  {  

    return {
      ...state,
      allContent: action.payload
    }
  }

  case 'SET_GET_CONTENT_ONCE':
   {  

     return {
       ...state,
       getContentOnce: true
     }
   }

//SET_SELECTED_APP-      -      -      -      -      -      -      -   


   case 'SET_SELECTED_APP':
   {  

     return {
       ...state,
       selectedApp: action.payload
     }
   }



   

//UPDATE_HASH-      -      -      -      -      -      -      -   



case 'UPDATE_HASH':
  {
    const hash = action.payload;

    return {
      ...state,
      hash: hash
    }

  }



//SET_GROUP_CONTENT   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_GROUP_CONTENT': {


  return {
    ...state,
    groupUrlContent: action.payload,
    groupLessonsState: { groupName: '', groupLessons: [], groupLessonsFound: false, showGroupLessonsLoader: false }

  }

}



//SET_GROUP_LESSONS   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_GROUP_LESSONS': {

  const { lessons, name } = action.payload;


  const obj = {
    groupName:              name,
    groupLessonsFound:      lessons.length > 0,
    groupLessons:           lessons,
    showGroupLessonsLoader: false
  }

  return {
    ...state,
    groupLessonsState: obj
  }

}


//SET_GROUP_LESSONS_LOADER   -      -      -      -      -      -      -      -      -      -      -      -



case 'SET_GROUP_LESSONS_LOADER': {
  
  const obj = {
    groupName:              state.groupLessonsState.groupName,
    groupLessonsFound:      state.groupLessonsState.groupLessonsFound,
    groupLessons:           state.groupLessonsState.groupLessons,
    showGroupLessonsLoader: true
  }

  return {
    ...state,
    groupLessonsState: obj
  }

}




//SET_USER_LESSONS   -      -      -      -      -      -      -      -      -      -      -      -



case 'SET_USER_LESSONS': {

  const res = action.payload;
  
  const obj = {
    userLessonsFound:     true,
    userLessons:          res,
    showUserLessonsLoader: false
  }

  return {
    ...state,
    userLessonsState: obj
  }

}


//SET_USER_VIDEOS   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_USER_VIDEOS': {

  const userVideos = action.payload;

  return {
    ...state,
    userVideos: userVideos
  }

}



//SET_TUTORIALS   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_TUTORIALS': {

  const tutorials = action.payload;

  return {
    ...state,
    tutorials: tutorials
  }

}



//SET_USER_LESSONS_LOADER   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_USER_LESSONS_LOADER': {
  
  const obj = {
    userLessonsFound:      state.userLessonsState.userLessonsFound,
    userLessons:           state.userLessonsState.userLessons,
    showUserLessonsLoader: true
  }

  return {
    ...state,
    userLessonsState: obj
  }

}



// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};

export type reducerType = ReturnType<typeof contentReducer>;

export { contentReducer };
